import { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import Config from "../../config";
import SurveyPopup from "./SurveyPopup";

const WelcomePopup = (props) => {
  const [visible, setVisible] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [Message, setMessage] = useState(Config.WelcomeMessage);
  const planName = sessionStorage.getItem("planName");
  useEffect(() => {
    if(planName === 'PodAmerica'){
        setVisible(true);
        setMessage(Message.replace('<userName>', sessionStorage.getItem("userName")).replace('<planName>', 'POD America'))
    } else {
        sessionStorage.setItem('isWelcomed', true);
        setShowSurvey(true)
    }
  }, []);

  const handleOK = () => {
    setVisible(false);
    sessionStorage.setItem('isWelcomed', true);
    setShowSurvey(true)
  }

  return (
    <>
    {!sessionStorage.getItem('isWelcomed') && <Modal
        open={visible}
        closable={false}
        footer={[
        <Button key="Ok" type="primary" onClick={handleOK}>
            OK
        </Button>,
        ]}
        >
        <p>
            {Message}
        </p>
        </Modal>}
    {showSurvey && <SurveyPopup />}
    </>
  );
};

export default WelcomePopup;
